import cn from 'classnames';
import { AnimatePresence } from 'framer-motion';
import { Translate } from 'i18n';
import { FC, PropsWithChildren, ReactNode, RefObject, useId } from 'react';
import {
  SMenu,
  SMenuList,
  SMenuTitle,
  SMenuWrapper,
  SPlus,
  SStartNewButton
} from './styled';

interface ILangDropdown {
  show: boolean;
  titleLocaleKey?: string;
  direction?: 'up' | 'down';
  menuRef?: RefObject<any>;
  openMenu?: () => void;
  btnTitleLocaleKey?: string;
  contentClassName?: string;
  renderChildren?: boolean;
  /** Rendered under the list, above the "add another" button. */
  footer?: ReactNode;
}

export const LangDropdown: FC<PropsWithChildren<ILangDropdown>> = ({
  show,
  direction,
  children,
  openMenu,
  titleLocaleKey,
  btnTitleLocaleKey,
  menuRef,
  contentClassName,
  renderChildren,
  footer
}) => {
  const yShift = direction === 'up' ? 'calc(-100% - 45px)' : 0;
  // So a screen reader announces the list as "Support language", rather than reading
  // the heading and the options as unrelated things that happen to be adjacent.
  const titleId = useId();

  return (
    <AnimatePresence>
      {show ? (
        <SMenu
          className={cn(contentClassName)}
          transition={{ duration: 0.2 }}
          initial={{ opacity: 0, y: -20, x: '-50%' }}
          animate={{ opacity: 1, y: yShift, x: '-50%' }}
          exit={{ opacity: 0, y: -20, x: '-50%' }}
          ref={menuRef}
        >
          {renderChildren ? (
            children
          ) : (
            <>
              <SMenuWrapper>
                <SMenuTitle id={titleId}>
                  <Translate str={titleLocaleKey ?? ''} />:
                </SMenuTitle>

                <SMenuList aria-labelledby={titleId}>{children}</SMenuList>

                {footer}
              </SMenuWrapper>

              <SStartNewButton onClick={openMenu}>
                <SPlus /> <Translate str={btnTitleLocaleKey ?? ''} />
              </SStartNewButton>
            </>
          )}
        </SMenu>
      ) : null}
    </AnimatePresence>
  );
};
